import React, { useState } from 'react';

export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      q: 'How does the OSSD program work?',
      a: 'Students can begin courses at any time and study at their own pace. Courses include instructional content aligned with the Ontario curriculum, with assignments and quizzes throughout. Final exams are completed online, supervised by an approved proctor, and official report cards are issued upon completion.'
    },
    {
      q: 'Are OSSD courses internationally recognized?',
      a: 'Yes. OSSD courses inspected by the Ontario Ministry of Education are accepted by universities and colleges in Canada and around the world. Online courses carry the same recognition as those taught in physical schools.'
    },
    {
      q: 'Can I earn the OSSD completely online?',
      a: 'Yes. Students can complete their OSSD requirements online. This includes earning the necessary credits, completing community involvement hours, and fulfilling literacy requirements to receive the Ontario Secondary School Diploma.'
    },
    {
      q: 'Who can register for OSSD courses?',
      a: 'Students of all backgrounds — local or international, full-time or part-time — are eligible to enroll. International students from Asia and other regions are welcome to join the OSSD program.'
    },
    {
      q: 'Is there a fixed registration timeline?',
      a: 'No. There are no set registration dates. Students may register for courses at any time throughout the year and begin learning right away.'
    },
    {
      q: 'What are the requirements to register?',
      a: 'Students must provide: (1) A transcript showing previous high-school courses (Ontario or international), (2) Government-issued identification, (3) Parent/guardian signature if under 18. Prerequisite courses may be required for certain subjects.'
    },
    {
      q: 'How long do courses take to complete?',
      a: 'Each OSSD course involves approximately 110 hours of study. Students can complete courses at their own pace, typically finishing most within 12 weeks. All courses must be completed within 10 months of registration.'
    },
    {
      q: 'Will my credits transfer to my home school?',
      a: 'Yes. After completing a course, official report cards and transcripts are sent to your home school for credit recognition according to Ontario education policies.'
    },
    {
      q: 'Are there any due dates or deadlines?',
      a: 'No. Students can work through courses at their own pace as long as the course is completed within the 10-month limit after registration.'
    },
    {
      q: 'What equipment do I need for online OSSD courses?',
      a: 'To participate online, students need: A computer (Windows or macOS), High-speed internet, A microphone/headset, and Microsoft Office or Google Office tools.'
    }
  ];

  return (
    <section id="faq" className="py-24 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="bg-amber-100 text-amber-600 px-4 py-2 rounded-full text-sm font-semibold border border-amber-200">Questions & Answers</span>
          <h2 className="text-5xl font-bold text-gray-900 mt-4 mb-4">Frequently Asked <span className="text-blue-600">Questions</span></h2>
          <p className="text-xl text-gray-600">Everything you need to know about OSSD at EduNexa</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white border-2 border-blue-100 rounded-xl overflow-hidden hover:border-blue-400 transition-colors shadow-sm hover:shadow-md">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full text-left p-6 flex justify-between items-center"
              >
                <span className="font-bold text-lg pr-8 text-gray-900">{faq.q}</span>
                <span className={`text-2xl ${openIndex === index ? 'text-amber-500' : 'text-blue-400'} font-bold`}>{openIndex === index ? '−' : '+'}</span>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-6">
                  <p className="text-gray-700 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-3xl p-10 text-center shadow-xl">
          <h3 className="text-2xl font-bold mb-4">Still Have Questions?</h3>
          <p className="text-lg text-blue-100 mb-6">Contact our admissions team for personalized answers</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="mailto:info@edunexa.ca" className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors">Email Us</a>
            <a href="tel:+15195005823" className="bg-amber-400 hover:bg-amber-500 text-blue-900 px-8 py-3 rounded-lg font-semibold transition-colors">Call Now</a>
          </div>
        </div>
      </div>
    </section>
  );
};
